import { X } from "@phosphor-icons/react";
import { Icon } from "@shopflo/ui/icon";
import { motion } from "motion/react";

/** Floating close affordance that sits ABOVE the sheet it belongs to (`bottom-full`).
    Requires a positioned ancestor whose top edge is the sheet's top edge, and that
    ancestor must NOT be `overflow-hidden` — the button renders outside its box.
    The space it needs is reserved by SHEET_CLOSE_RESERVE_PX (see useFamilyTrayHeights).

    `layout`: the sheet's height morph is FLIP, so the shell's real height — and therefore
    this button's `bottom-full` anchor — snaps in a single frame while the sheet only *looks*
    like it is tweening. Own layout animation, tuned to the same spring, keeps it in step.
    Centering uses `mx-auto`, not `-translate-x-1/2`: layout projection writes `transform`.

    Fades on its own: the shell's `y: 100%` exit only travels the shell's height, and this
    button sits outside that box, so a pure transform would leave it visible at the
    viewport bottom after the sheet is gone. */
export const SheetCloseButton = ({ onClose }: { onClose: () => void }) => (
  <motion.button
    type="button"
    aria-label="Close"
    onClick={onClose}
    layout
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{
      opacity: { duration: 0.15, ease: "easeOut" },
      layout: { type: "spring", bounce: 0, duration: 0.45 },
    }}
    className="absolute bottom-full inset-x-0 z-10 mx-auto mb-3 flex size-9 items-center justify-center rounded-full border border-white/[0.24] bg-black/25">
    <Icon IconComponent={X} size="xxs" iconProps={{ color: "#ffffff", weight: "bold" }} />
  </motion.button>
);
